import '../styles/Modules.css';

export const CurrentYear = ({currentYear}) => {
    
    return (
        // <div className='module-container-slim'>
        <div className='current-year-display'>
            <span className='current-year-header'>Current BI Year</span>
            <span className='current-year'>{currentYear}</span>
        </div>
    );
}
